// extracted by mini-css-extract-plugin
export default {"container":"FormErrorMessage__container--1Bw","icon":"FormErrorMessage__icon--1WI"};